import type { BlockDefinition } from '@tsagko/label-contracts'

/**
 * Returns true when two block bodies are equal modulo fields that differ
 * between a draft and its source published version (`updatedAt`,
 * `version`) or that carry designer-only UI state with no print impact
 * (`dimensionsLocked` — a lock toggle must never force a version bump).
 * Used by the same-content promote skip: if the draft is structurally
 * identical to the latest published body, promotion is a no-op and the
 * caller can bake against the existing version.
 */
export function deepEqualBlockBody(a: BlockDefinition, b: BlockDefinition): boolean {
  const stripped = (x: BlockDefinition) => {
    const { updatedAt: _u, version: _v, dimensionsLocked: _d, ...rest } = x
    return rest
  }
  return JSON.stringify(stripped(a)) === JSON.stringify(stripped(b))
}
